import configuration from "../configuration";
import { VorsorgeInfo } from "../contexts/heyFlowLead";
import { renderPrice } from "../utils/price";
import { formatDateDe, vorsorgeStatus, vorsorgeStatusText } from "../utils/vorsorge";

interface Props {
  vorsorge: VorsorgeInfo;
  className?: string;
}

/** Hinweisbox auf der Angebotsseite: Vorsorge ist angerechnet, Preis gesichert, Gültigkeit. */
export function VorsorgeBanner({ vorsorge, className }: Props) {
  const status = vorsorgeStatus(vorsorge);
  const statusText = vorsorgeStatusText(status);
  const kontoUrl = `${configuration.vorsorge.url}/konto`;

  if (statusText) {
    return (
      <div className={`rounded-xl border border-yellow-300 bg-yellow-50 px-5 py-4 text-sm ${className ?? ""}`}>
        <div className="font-semibold mb-1">Einlösung von Vorsorgeplan {vorsorge.planNumber}</div>
        <div>{statusText}</div>
        <a href={kontoUrl} className="underline mt-2 inline-block">
          Zum Vorsorge-Konto
        </a>
      </div>
    );
  }

  return (
    <div className={`rounded-xl bg-green/15 px-5 py-4 text-sm ${className ?? ""}`}>
      <div className="font-semibold mb-2">Deine Vorsorge {vorsorge.planNumber} ist angerechnet</div>
      <ul className="space-y-1">
        <li>
          {vorsorge.cremationLabel} zum gesicherten Preis von{" "}
          <span className="font-semibold">{renderPrice(vorsorge.cremationPriceCents / 100, "EUR", true)}</span>
        </li>
        <li>
          Bereits angespart und hier abgezogen:{" "}
          <span className="font-semibold">{renderPrice(vorsorge.creditCents / 100, "EUR", true)}</span>
          {vorsorge.creditRatesCents > 0 && (
            <span className="text-neutral-600">
              {" "}
              (Ersteinzahlung {renderPrice(vorsorge.creditInitialCents / 100, "EUR", true)} + Raten{" "}
              {renderPrice(vorsorge.creditRatesCents / 100, "EUR", true)})
            </span>
          )}
        </li>
        <li>Du zahlst nur den Rest. Weitere Leistungen kannst du unten ergänzen.</li>
        <li className="text-neutral-600">Angebot gültig bis {formatDateDe(vorsorge.expiresAt)}.</li>
      </ul>
      {vorsorge.testMode && (
        <div className="mt-3 inline-block rounded-md bg-yellow-100 px-2 py-1 text-xs font-medium text-yellow-900">
          Testmodus: Zahlung läuft über Stripe-Testkarten
        </div>
      )}
    </div>
  );
}
